"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityFleet = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var ResourceType_1 = require("../../ResourceType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var SecurityFleet = (function (_super) {
    __extends(SecurityFleet, _super);
    function SecurityFleet() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SECURITY_FLEET,
            tags: [Tags_1.Tags.SPACE],
            cost: 12,
            resourceType: ResourceType_1.ResourceType.FIGHTER,
            metadata: {
                cardNumber: '028',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 titanium to add 1 fighter resource to this card.', function (eb) {
                        eb.titanium(1).startAction.fighter();
                    }).br;
                    b.vpText('1 VP for each fighter resource on this card.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.fighter(1, 1),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    SecurityFleet.prototype.getVictoryPoints = function () {
        return this.resourceCount;
    };
    SecurityFleet.prototype.play = function () {
        return undefined;
    };
    SecurityFleet.prototype.canAct = function (player) {
        return player.titanium > 0;
    };
    SecurityFleet.prototype.action = function (player) {
        player.titanium--;
        player.addResourceTo(this, 1);
        return undefined;
    };
    return SecurityFleet;
}(Card_1.Card));
exports.SecurityFleet = SecurityFleet;
